export const GET_BANNERS = 'GET_BANNERS';
export const GET_BANNERS_DONE = 'GET_BANNERS_DONE';



// WEBPACK FOOTER //
// ./app/constants/bannersTypes.js